import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Polyline,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(
          Path,
          {
            d: "M4 7V4a2 2 0 0 1 2-2h8.5L20 7.5V20a2 2 0 0 1-2 2h-6",
            stroke: `${color}`
          }
        ),
        /* @__PURE__ */ jsx(Polyline, { points: "14 2 14 8 20 8", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M5 17a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M7 16.5 8 22l-3-1-3 1 1-5.5", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "FileBadge";
const FileBadge = memo(themed(Icon));
export {
  FileBadge
};
//# sourceMappingURL=file-badge.js.map
